// THE FILE SHELLVERSIONINFO.TS IS AUTOMATICALLY GENERATED DURING BUILD PROCESS
// MANUAL CHANGES TO THIS FILE WILL BE OVERWRITTEN !!!

export const SHELL_VERSION_INFO = {
VERSION : '1.27.2',
BUILD_TS: '2026-08-07T07:11:59.214Z'
};

